/*
 * page-container
 */
import { cn } from "../utils"
import { cva, type VariantProps } from "class-variance-authority"
import type { ReactNode } from "react"

export type ContainerProps = VariantProps<typeof containerVariants> & {
	children: ReactNode
	className?: string
}

export function Container({
	width,
	padding,
	gap,
	className,
	children,
}: ContainerProps) {
	return (
		<div className={cn(containerVariants({ className, width, padding, gap }))}>
			{children}
		</div>
	)
}

/* Variants */
export const containerVariants = cva("flex w-full flex-1 flex-col", {
	variants: {
		width: {
			default: "max-w-[600px]",
			sm: "max-w-[500px]",
			lg: "max-w-[800px]",
			xl: "max-w-[1000px]",
			xxl: "max-w-[1200px]",
			xxxl: "max-w-[1400px]",
		},
		padding: {
			default: "xs:px-2 xs:py-4 px-1 py-2 md:px-3 md:py-6 lg:px-4 lg:py-8",
			sm: "xs:px-1 xs:py-2 px-0.5 py-1 md:px-1.5 md:py-3 lg:px-2 lg:py-4",
			lg: "xs:px-3 xs:py-6 px-2 py-4 md:px-5 md:py-9 lg:px-6 lg:py-12",
			xl: "xs:px-4 xs:py-8 px-4 py-8 md:px-6 md:py-12 lg:px-8 lg:py-16",
		},
		gap: {
			default: "xs:gap-2 gap-1 sm:gap-4 md:gap-6 lg:gap-8",
			sm: "gap-1 sm:gap-2 md:gap-3 lg:gap-4",
			lg: "xs:gap-3 gap-2 sm:gap-6 md:gap-9 lg:gap-12",
			xl: "xs:gap-4 gap-3 sm:gap-8 md:gap-12 lg:gap-16",
		},
	},
	defaultVariants: {
		width: "default",
		padding: "default",
		gap: "default",
	},
})
